export interface DataEntity_Detail_05_Interface {
  id: number,
  main_id: number,

  uncertainty: string,
  converage: string,
  indication: string,
  correction: string,
  reference: string,

  value: string,
  before:boolean,
  status:number,
}

export function Empty_DataEntity_Detail_05_Interface(): DataEntity_Detail_05_Interface {
  return {
    id: 0,
    main_id: 0,

    uncertainty: '',
    converage: '',
    indication: '',
    correction: '',
    reference: '',
    value: '',
    status:0,

    before:false
  }
}
